import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "otherInput", "hiddenField"]

  toggle() {
    const value = this.selectTarget.value
    if (value === "Other") {
      this.otherInputTarget.classList.remove("hidden")
      this.otherInputTarget.focus()
      this.updateHidden()
    } else {
      this.otherInputTarget.classList.add("hidden")
      this.otherInputTarget.value = ""
      this.hiddenFieldTarget.value = value
    }
  }

  updateHidden() {
    const selectValue = this.selectTarget.value
    if (selectValue === "Other") {
      const otherText = this.otherInputTarget.value.trim()
      this.hiddenFieldTarget.value = otherText ? `Other: ${otherText}` : "Other"
    } else {
      this.hiddenFieldTarget.value = selectValue
    }
  }

  connect() {
    this.otherInputTarget.addEventListener("input", () => this.updateHidden())
  }
}
